<template>
	<div style="position: relative;width: 100%;height: 100%;">
		<div class="middle">
			<el-form
					:rules="rules"
					ref="loginForm"
					v-loading="loading"
					element-loading-text="正在登录..."
					element-loading-spinner="el-icon-loading"
					element-loading-background="rgba(0, 0, 0, 0.8)"
					:model="loginForm"
					class="loginContainer">
				<h3 class="loginTitle">系统登录</h3>
				<el-form-item prop="username">
					<el-input size="normal" type="text" v-model="loginForm.username" auto-complete="off"
							  placeholder="请输入用户名"></el-input>
				</el-form-item>
				<el-form-item prop="password">
					<el-input size="normal" type="password" v-model="loginForm.password" auto-complete="off"
							  placeholder="请输入密码" show-password></el-input>
				</el-form-item>
				<el-form-item prop="code">
					<el-input size="normal" type="text" v-model="loginForm.code" auto-complete="off"
							  placeholder="点击图片更换验证码" @keydown.enter.native="submitLogin" style="width: 250px"></el-input>
					<img :src="vcUrl" @click="updateVerifyCode" alt="" style="cursor: pointer">
				</el-form-item>
				<!-- <el-checkbox size="normal" class="loginRemember" v-model="checked"></el-checkbox> -->
				<el-button size="normal" type="primary" style="width: 100%;" @click="submitLogin">登录</el-button>
			</el-form>

		</div>
		<div class="beian">
			<div style="display: flex;justify-content: center;font-size: 12px;">
				<div>备案/许可证编号：</div>
				<a style="cursor: pointer;" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">鲁ICP备2024058246号</a>
				<div class="gongan"></div>
				<a href= "https://beian.mps.gov.cn/#/query/webSearch?code=37142502000325" rel="noreferrer" target="_blank">鲁公网安备37142502000325</a>
			</div>
		</div>
	</div>
</template>

<script>

    export default {
        name: "Login",
        data() {
            return {
                loading: false,
                vcUrl: '/apis/verifyCode?time='+new Date(),
                loginForm: {
                    username: '',
                    password: '',
                    code:''
                },
                checked: true,
                rules: {
                    username: [{required: true, message: '请输入用户名', trigger: 'blur'}],
                    password: [{required: true, message: '请输入密码', trigger: 'blur'}],
                    code: [{required: true, message: '请输入验证码', trigger: 'blur'}]
                }
            }
        },
        methods: {
            updateVerifyCode() {
                this.vcUrl = '/apis/verifyCode?time='+new Date();
            },
            submitLogin() {
                this.$refs.loginForm.validate((valid) => {
                    if (valid) {
                        this.loading = true;
                        this.postRequest('/doLogin', this.loginForm).then(resp => {
                            this.loading = false;
                            if (resp) {
                                this.$store.commit('INIT_CURRENTHR', resp.obj);
                                window.sessionStorage.setItem("user", JSON.stringify(resp.obj));
                                let path = this.$route.query.redirect;
								console.log("redirect==="+path)
                                this.$router.push((path == '/' || path == undefined) ? '/home' : path);
                            }else{
                                this.vcUrl = '/apis/verifyCode?time='+new Date();
                            }
                        })
                    } else {
                        return false;
                    }
                });
            }
        }
    }
</script>

<style scoped lang="scss">
	.gongan {
		background: url('../assets/gongan.jpg') no-repeat center;
		background-size: 100%;
		width: 20px;
		height: 20px;
		margin-left: 20px;
		margin-right: 8px;
	}
	.beian {
		position: absolute;
		bottom: 12px;
		width: 100%;
		text-align: center;
	}
    .loginContainer {
        border-radius: 15px;
        background-clip: padding-box;
        margin: 180px auto;
        width: 350px;
        padding: 15px 35px 15px 35px;
        background: #fff;
        border: 1px solid #eaeaea;
        box-shadow: 0 0 25px #cac6c6;
    }

    .loginTitle {
        margin: 15px auto 20px auto;
        text-align: center;
        color: #505458;
    }

    .loginRemember {
        text-align: left;
        margin: 0px 0px 15px 0px;
    }
    .el-form-item__content{
        display: flex;
        align-items: center;
    }
	.middle {
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
	}
</style>
